import React ,{ Component }from 'react';
import ErrorBoundaryUI from './screens/ErrorBoundaryUI';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state to show fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details, optionally send to an error reporting service.
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return <ErrorBoundaryUI/>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
